import { API, jsonAuthHeaders } from "./config";

export const EMPTY_HISTORIA_FORM = {
  lugar: "", fecha: "", odontologo: "", matricula: "",
  paciente: "", obraSocial: "", fechaNac: "", tel: "", edad: "",
  estadoCivil: "", nacionalidad: "", dni: "", cel: "", domicilio: "",
  profesion: "", titular: "", trabajo: "", jerarquia: "",
  padreVive: "", enfPadre: "", madreVive: "", enfMadre: "",
  hermanos: "", hermanosSanos: "", enfermedad: "", enfermedadDetalle: "",
  tratamientoMedico: "", tratamientoDetalle: "",
  medicamentosHabituales: "", medicamentosUltimos5: "",
  deporte: "", malestarDeporte: "", alergico: "", alergiasDetalle: "",
  cicatrizacion: "", colageno: "", fiebreReumatica: "",
  medicacionProteccion: "", diabetico: "", controlDiabetes: "",
  problemaCardiaco: "", cualCardiaco: "", aspirinaAnticoagulante: "",
  frecuenciaAnticoagulante: "", presionAlta: "", chagas: "",
  tratamientoChagas: "", problemaRenal: "", ulcera: "",
  hepatitis: "", tipoHepatitis: "", problemaHepatico: "",
  cualHepatico: "", convulsiones: "", epilepsia: "", medicacionEpilepsia: "",
  sifilis: "", infectoContagiosa: "", transfusiones: "", operado: "",
  deQueOperacion: "", cuandoOperacion: "", problemaRespiratorio: "",
  cualRespiratorio: "", fuma: "", embarazada: "", mesesEmbarazo: "",
  otrasEnfermedades: "", tratamientosAlternativos: "", medicoClinico: "",
  clinicaDerivacion: "",
  motivoConsulta: "", otroProfesional: "", tomoMedicamento: "",
  medicamentosConsulta: "", desdeCuando: "", resultados: "", tipoDolor: "",
  localizadoDonde: "", irradiadoHacia: "", calmaCon: "",
  golpeDientes: "", cuandoGolpe: "", comoGolpe: "",
  fracturaDiente: "", cualDiente: "", tratamientoFractura: "",
  dificultadHablar: "", dificultadMasticar: "", dificultadAbrirBoca: "",
  dificultadTragar: "", manchas: "", abultamientos: "", ulceraciones: "",
  ampollas: "", otrosLesiones: "", sangradoEncías: "", cuandoSangrado: "",
  pus: "", deDondePus: "", movilidadDientes: "", dientesAltos: "",
  caraHinchada: "", tratamientoCara: "", azucarDiario: "", indicePlaca: "",
  higieneBucal: "", sarro: "", enfermedadPeriodontal: "",
  diagnostico: "", planTratamiento: "", observaciones: "",
  consentimientoNombre: "", consentimientoDni: "",
  consentimientoDomicilio: "", consentimientoDr: "",
  firmaBase64: "",
};

function mapDbToFormData(dataPaciente, dbData = {}) {
  const p = dataPaciente?.data || dataPaciente || {};
  const nombreCompleto = [p.nombre, p.apellido].filter(Boolean).join(" ");

  return {
    ...EMPTY_HISTORIA_FORM,
    paciente: nombreCompleto,
    dni: p.dni || "",
    tel: p.telefono || "",
    obraSocial: dbData.obra_social || p.obraSocial || "",
    fechaNac: dbData.fecha_nacimiento || "",
    lugar: dbData.lugar || "",
    fecha: dbData.fecha_consulta || "",
    odontologo: dbData.odontologo || "",
    matricula: dbData.matricula || "",
    edad: dbData.edad || "",
    estadoCivil: dbData.estado_civil || "",
    nacionalidad: dbData.nacionalidad || "",
    cel: dbData.celular || "",
    domicilio: dbData.domicilio || "",
    profesion: dbData.profesion || "",
    titular: dbData.titular || "",
    trabajo: dbData.lugar_trabajo || "",
    jerarquia: dbData.jerarquia || "",
    padreVive: dbData.padre_vive || "",
    enfPadre: dbData.enf_padre || "",
    madreVive: dbData.madre_vive || "",
    enfMadre: dbData.enf_madre || "",
    hermanos: dbData.hermanos || "",
    hermanosSanos: dbData.hermanos_sanos || "",
    enfermedad: dbData.enfermedad_personal || "",
    enfermedadDetalle: dbData.enfermedad_detalle || "",
    tratamientoMedico: dbData.tratamiento_medico || "",
    tratamientoDetalle: dbData.tratamiento_detalle || "",
    medicamentosHabituales: dbData.medicamentos_habituales || "",
    medicamentosUltimos5: dbData.medicamentos_ultimos_5 || "",
    deporte: dbData.deporte || "",
    malestarDeporte: dbData.malestar_deporte || "",
    alergico: dbData.alergico || "",
    alergiasDetalle: dbData.alergias_detalle || "",
    cicatrizacion: dbData.cicatrizacion || "",
    colageno: dbData.colageno || "",
    fiebreReumatica: dbData.fiebre_reumatica || "",
    medicacionProteccion: dbData.medicacion_proteccion || "",
    diabetico: dbData.diabetico || "",
    controlDiabetes: dbData.control_diabetes || "",
    problemaCardiaco: dbData.problema_cardiaco || "",
    cualCardiaco: dbData.cual_cardiaco || "",
    aspirinaAnticoagulante: dbData.aspirina_anticoagulante || "",
    frecuenciaAnticoagulante: dbData.frecuencia_anticoagulante || "",
    presionAlta: dbData.presion_alta || "",
    chagas: dbData.chagas || "",
    tratamientoChagas: dbData.tratamiento_chagas || "",
    problemaRenal: dbData.problema_renal || "",
    ulcera: dbData.ulcera || "",
    hepatitis: dbData.hepatitis || "",
    tipoHepatitis: dbData.tipo_hepatitis || "",
    problemaHepatico: dbData.problema_hepatico || "",
    cualHepatico: dbData.cual_hepatico || "",
    convulsiones: dbData.convulsiones || "",
    epilepsia: dbData.epilepsia || "",
    medicacionEpilepsia: dbData.medicacion_epilepsia || "",
    sifilis: dbData.sifilis || "",
    infectoContagiosa: dbData.infecto_contagiosa || "",
    transfusiones: dbData.transfusiones || "",
    operado: dbData.operado || "",
    deQueOperacion: dbData.de_que_operacion || "",
    cuandoOperacion: dbData.cuando_operacion || "",
    problemaRespiratorio: dbData.problema_respiratorio || "",
    cualRespiratorio: dbData.cual_respiratorio || "",
    fuma: dbData.fuma || "",
    embarazada: dbData.embarazada || "",
    mesesEmbarazo: dbData.meses_embarazo || "",
    otrasEnfermedades: dbData.otras_enfermedades || "",
    tratamientosAlternativos: dbData.tratamientos_alternativos || "",
    medicoClinico: dbData.medico_clinico || "",
    clinicaDerivacion: dbData.clinica_derivacion || "",
    motivoConsulta: dbData.motivo_consulta || "",
    otroProfesional: dbData.otro_profesional || "",
    tomoMedicamento: dbData.tomo_medicamento || "",
    medicamentosConsulta: dbData.medicamentos_consulta || "",
    desdeCuando: dbData.desde_cuando || "",
    resultados: dbData.resultados || "",
    tipoDolor: dbData.tipo_dolor || "",
    localizadoDonde: dbData.localizado_donde || "",
    irradiadoHacia: dbData.irradiado_hacia || "",
    calmaCon: dbData.calma_con || "",
    golpeDientes: dbData.golpe_dientes || "",
    cuandoGolpe: dbData.cuando_golpe || "",
    comoGolpe: dbData.como_golpe || "",
    fracturaDiente: dbData.fractura_diente || "",
    cualDiente: dbData.cual_diente || "",
    tratamientoFractura: dbData.tratamiento_fractura || "",
    dificultadHablar: dbData.dificultad_hablar || "",
    dificultadMasticar: dbData.dificultad_masticar || "",
    dificultadAbrirBoca: dbData.dificultad_abrir_boca || "",
    dificultadTragar: dbData.dificultad_tragar || "",
    manchas: dbData.manchas || "",
    abultamientos: dbData.abultamientos || "",
    ulceraciones: dbData.ulceraciones || "",
    ampollas: dbData.ampollas || "",
    otrosLesiones: dbData.otros_lesiones || "",
    sangradoEncías: dbData.sangrado_encias || "",
    cuandoSangrado: dbData.cuando_sangrado || "",
    pus: dbData.pus || "",
    deDondePus: dbData.de_donde_pus || "",
    movilidadDientes: dbData.movilidad_dientes || "",
    dientesAltos: dbData.dientes_altos || "",
    caraHinchada: dbData.cara_hinchada || "",
    tratamientoCara: dbData.tratamiento_cara || "",
    azucarDiario: dbData.azucar_diario || "",
    indicePlaca: dbData.indice_placa || "",
    higieneBucal: dbData.higiene_bucal || "",
    sarro: dbData.sarro || "",
    enfermedadPeriodontal: dbData.enfermedad_periodontal || "",
    diagnostico: dbData.diagnostico || "",
    planTratamiento: dbData.plan_tratamiento || "",
    observaciones: dbData.observaciones || "",
    consentimientoNombre: dbData.consentimiento_nombre || "",
    consentimientoDni: dbData.consentimiento_dni || "",
    consentimientoDomicilio: dbData.consentimiento_domicilio || "",
    consentimientoDr: dbData.consentimiento_dr || "",
    firmaBase64: dbData.firma_base64 || "",
  };
}

export async function fetchHistoriaClinicaFormData(pacienteId) {
  const [respPaciente, respHistoria] = await Promise.all([
    fetch(`${API}/pacientes/${pacienteId}`, { headers: jsonAuthHeaders() }),
    fetch(`${API}/pacientes/${pacienteId}/historia-clinica`, { headers: jsonAuthHeaders() }),
  ]);

  if (!respPaciente.ok) {
    throw new Error("No se pudo cargar el paciente");
  }

  const dataPaciente = await respPaciente.json();
  const result = respHistoria.ok ? await respHistoria.json() : { success: false };

  if (result.success && result.data) {
    return mapDbToFormData(dataPaciente, result.data);
  }

  return mapDbToFormData(dataPaciente);
}
